<mat-card class="card-mobile" appearance="outlined">
    <mat-card-header style="padding: 12px 12px 0px 12px;">
    <div class="card-header-mobile">
      <img class="card-provider-image-mobile" src="{{photo}}" alt="Image of a Shiba Inu" style="margin-right: 40px;">
      <div class="card-provider-wait-time-container-mobile">
        <div class="card-provider-book-as-soon-as-mobile">
            {{soonAsText}}
        </div>
        <div class="card-provider-availability-mobile" *ngIf="availability!=null&&availability!=''">
            {{waitTime}}
        </div>
      </div>
    </div>
    </mat-card-header>
    <mat-card-content class="card-provider-content-mobile">
      <mat-card-title class="card-provider-title-mobile">{{name}}</mat-card-title>
      <mat-card-subtitle class="card-provider-subtitle-mobile">{{specialties}}</mat-card-subtitle>
    </mat-card-content>
    <mat-card-actions class="card-provider-actions-mobile">
        <div class="card-provider-detail-bottom-left">{{virtualVisitText}}</div>
        <button mat-button class="action-button-primary" (click)="bookNow()">{{scheduleText}}</button>
    </mat-card-actions>
</mat-card>